import { Button, Flex, Text } from "@chakra-ui/react";
import { FunctionComponent, PropsWithChildren } from "react";
import { AdminFormButtons } from "src/components/Layout/AdminFormButtons";
import { NavigationBlocker } from "src/components/NavigationBlocker";
import {
  EditFormTemplateBackButton,
  EditFormTemplateBackButtonProps,
} from "./BackButton";

type Props = {
  formId?: string;
  isLoading?: boolean;
  hasChanges?: boolean;
  onClearChanges?: () => void;
} & EditFormTemplateBackButtonProps;

/**
 * Used as refs
 */
export const EditFormTemplateActionBar: FunctionComponent<
  PropsWithChildren<Props>
> = (props) => {
  const { formId, backPath, children, hasChanges, onClearChanges } = props;

  return (
    <AdminFormButtons insideTabPanel>
      <Flex justifyContent="space-between" grow="1">
        {children ? (
          children
        ) : (
          <StandardActions
            formId={formId}
            backPath={backPath}
            hasChanges={hasChanges}
            onClearChanges={onClearChanges}
          />
        )}
      </Flex>
      <NavigationBlocker hasChanges={hasChanges ?? false} />
    </AdminFormButtons>
  );
};

type StandardActionProps = Omit<Props, "actionBarRef">;

const StandardActions: FunctionComponent<StandardActionProps> = (props) => {
  const { formId, backPath, isLoading, hasChanges, onClearChanges } = props;

  return (
    <>
      <EditFormTemplateBackButton backPath={backPath} />
      <Flex direction="column" gap={2}>
        <Flex gap={2}>
          {hasChanges && (
            <Button
              variant="ghost"
              colorScheme="gray"
              onClick={onClearChanges}
              gridColumn="3"
            >
              Clear unpublished changes
            </Button>
          )}
          <Button
            form={formId}
            type="submit"
            isLoading={isLoading}
            isDisabled={!hasChanges}
          >
            Publish changes
          </Button>
        </Flex>
        {hasChanges && (
          <Text textAlign="right" fontSize="xs" color="gray.500">
            Unpublished changes
          </Text>
        )}
      </Flex>
    </>
  );
};
